export class RequestLetter {
    private _html: string;

    private _trackingId: number;

    private _submitterName: string;

    private _createdDate:string;

    get html(): string {
        return this._html;
    }

    get trackingId(): number {
        return this._trackingId;
    }

    get submitterName(): string {
        return this._submitterName;
    }

    get createdDate(): string {
        return this._createdDate;
    }

    constructor(html: string,submitterName:string,trackingId:number,createdDate:string) {
        this._html = html;
        this._submitterName = submitterName;
        this._trackingId = trackingId;
        this._createdDate = createdDate;
    }

   toJSON(): any {
        return {
            html: this._html,
            submitterName: this._submitterName,
            trackingId: this._trackingId,
            createdDate: this._createdDate
        }
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetail/models/requestLetter.ts
 **/